module.exports = __webpack_public_path__ + "img/youmu konpaku lunar war gardener.c2219ed2.png";